export class ScriptBase {
}
